"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_RICH_TEXT_PLACEHOLDER = exports.ANALYSIS_COLUMN_POSITION = exports.LIBRARY_ITEM_TYPES = void 0;
exports.LIBRARY_ITEM_TYPES = {
    UNDEFINED: { displayName: 'Undefined', value: 0 },
    RICH_TEXT: { displayName: 'Rich Text', value: 100 },
    EXCEL_CHART: { displayName: 'Excel chart', value: 300 },
    EXCEL_NAMED_RANGE: { displayName: 'Excel table', value: 301 },
    EXCEL_CELL_RANGE: { displayName: 'Excel table', value: 302 },
    POWER_BI_REPORT: { displayName: 'Power BI Report', value: 400 },
    POWER_BI_REPORT_PAGE: { displayName: 'Power BI Tab', value: 401 },
    POWER_POINT_GROUP: { displayName: 'PowerPoint Object', value: 500 },
};
exports.ANALYSIS_COLUMN_POSITION = {
    LEFT: 1,
    RIGHT: 2,
};
exports.EMPTY_RICH_TEXT_PLACEHOLDER = '(New text-box)';
